import React, { useMemo, useState } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import { useTranslation } from "react-i18next";
import {
  emptyDonut,
  getTotalValue,
  primaryColor,
  tooltipContentStyle,
} from "utils/dashboardUtils";
import DisplayPrice from "components/common/DisplayPrice";

const APP_COLOR = primaryColor;
const POS_COLOR = "#DE235C";
const AppVsPOS = ({ revenueBySource }) => {
  const { t } = useTranslation();

  const donut = useMemo(() => {
    const appData = revenueBySource?.find(
      (item) => item.label?.toLowerCase() === "app",
    );

    return [
      {
        label: "App",
        value: appData?.value ?? 0,
        color: APP_COLOR,
      },
      {
        label: "POS",
        value: 0, // 🔒 always hard-coded
        color: POS_COLOR,
      },
    ];
  }, [revenueBySource]);

  const total = donut.reduce((sum, item) => sum + item.value, 0);
  console.log("Total is ", total)

  const [activeValue, setActiveValue] = useState(donut[0].value);

  const totalValue = getTotalValue(donut);
  const chartData = totalValue === 0 ? emptyDonut : donut;
  console.log("chartData IS",chartData);

  return (
    <div className="sentiment_card dashboard_common_card app_vs_pos">
      <h3 className="fs_20">{t("App Vs POS")}</h3>

      {/* Donut */}
      <div className="sentiment_chart">
        <ResponsiveContainer width={175} height={175}>
          <PieChart>
            <Pie
              data={chartData}
              dataKey="value"
              nameKey="label"
              innerRadius={60}
              outerRadius={80}
              startAngle={90}
              endAngle={-270}
              stroke="none"
              onMouseEnter={(_, index) => setActiveValue(donut[index].value)}
              onMouseLeave={() => setActiveValue(donut[0].value)}
            >
              {chartData.map((item, index) => (
                <Cell key={index} fill={item.color} />
              ))}
            </Pie>

            {totalValue > 0 && (
              <Tooltip
                formatter={(value, name) => [`${value}%`, t(name)]}
                cursor={false}
                contentStyle={tooltipContentStyle}
              />
            )}
          </PieChart>
        </ResponsiveContainer>

        <div className="sentiment_center">
          {totalValue === 0 ? (
            <p>{t("No data")}</p>
          ) : (
            <>
              <DisplayPrice value={total} width="14" height="15" />
              <p>{t("Revenue")}</p>
            </>
          )}
        </div>
      </div>

      <div className="donut_legend">
        {chartData?.map((item) => (
          <div key={item.name} className="donut_legend_item g_between">
            <div className="heading_label">
              <span className="dot" style={{ background: item.color }} />
              <strong>{item.label}</strong>
            </div>
            <DisplayPrice value={item?.value} width="14" height="14" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default AppVsPOS;
